import Agilite from 'agilite'
import CoreEnums from '../../../../core/utils/enums'
import store from '../../../../store'
import { getDataWithSync } from '../../../../db/dbSync'
import { STORES } from '../../../../db/indexedDB'

const agilite = new Agilite({
  apiServerUrl: process.env.REACT_APP_AGILITE_API_URL,
  apiKey: process.env.REACT_APP_AGILITE_API_KEY
})

export const readTerms = () => {
  return new Promise((resolve, reject) => {
    let qry = { entityRef: store.getState().core.entity._id }
    let response = null
    let errorMessage = null

    ;(async () => {
      try {
        response = await agilite.Connectors.execute('terms_conditions', 'read', { filter: JSON.stringify(qry) })
        resolve(response.data)
      } catch (e) {
        if (e.response?.data?.errorMessage) {
          errorMessage = e.response.data.errorMessage
        } else if (e.message) {
          errorMessage = e.message
        } else {
          errorMessage = CoreEnums.errorMessages.UNKNOWN_ERROR
        }

        reject(errorMessage)
      }
    })()
  })
}

export const readTermsPwa = () => {
  return new Promise((resolve, reject) => {
    let qry = { entityRef: store.getState().core.entity._id }

    let errorMessage = null

    ;(async () => {
      try {
        const terms = await getDataWithSync(STORES.TERMS, {
          body: {
            filter: JSON.stringify(qry)
          },
          requestConfig: {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'profile-key': 'terms_conditions',
              'route-key': 'read'
            }
          }
        })

        resolve(terms)
      } catch (e) {
        if (e.response?.data?.errorMessage) {
          errorMessage = e.response.data.errorMessage
        } else if (e.message) {
          errorMessage = e.message
        } else {
          errorMessage = CoreEnums.errorMessages.UNKNOWN_ERROR
        }

        reject(errorMessage)
      }
    })()
  })
}

export const addTerm = (data) => {
  return new Promise((resolve, reject) => {
    let response = null
    let errorMessage = null

    ;(async () => {
      try {
        response = await agilite.Connectors.execute('terms_conditions', 'create', {
          data: JSON.stringify({ ...data, entityRef: store.getState().core.entity._id })
        })
        resolve(response.data)
      } catch (e) {
        if (e.response?.data?.errorMessage) {
          errorMessage = e.response.data.errorMessage
        } else if (e.message) {
          errorMessage = e.message
        } else {
          errorMessage = CoreEnums.errorMessages.UNKNOWN_ERROR
        }

        reject(errorMessage)
      }
    })()
  })
}

export const updateTerm = (recordId, data) => {
  return new Promise((resolve, reject) => {
    let response = null
    let errorMessage = null

    ;(async () => {
      try {
        response = await agilite.Connectors.execute('terms_conditions', 'update', {
          recordId,
          data: JSON.stringify(data)
        })
        resolve(response.data)
      } catch (e) {
        if (e.response?.data?.errorMessage) {
          errorMessage = e.response.data.errorMessage
        } else if (e.message) {
          errorMessage = e.message
        } else {
          errorMessage = CoreEnums.errorMessages.UNKNOWN_ERROR
        }

        reject(errorMessage)
      }
    })()
  })
}
